<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row
          justify="center"
          align="center"
        >
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <login />

            <v-row
              justify="end"
              align="center"
              class="mt-5"
            >
              <v-btn
                class="grey--text"
                small
                text
                rounded
                :to="{ name: 'reset-password' }"
              >
                Reset password
              </v-btn>
            </v-row>

            <tenant-session-select-dialog />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Login from '@/components/LoginCard.vue'
import TenantSessionSelectDialog from "../components/Auth/TenantSessionSelectDialog"

export default {
  components: {
    TenantSessionSelectDialog,
    Login
  }
}
</script>
